module.exports = __webpack_public_path__ + "img/line2.0550b8ff.png";